import React, { forwardRef, useState, useImperativeHandle, useEffect } from 'react';
import * as Tone from 'tone';
// import { Textures } from './Textures';

// eslint-disable-next-line react/display-name
const SamplePlayer = forwardRef((props, ref) => {
  // const [samplerLoaded, setSamplerLoaded] = useState(false);
  const [samplers, setSamplers] = useState({});
  // const [pitchValues, setPitchValues] = useState([0, 0, 0, 0, 0, 0, 0, 0]);
  const [gainNodes, setGainNodes] = useState({});
  const [monitor, setMonitor] = useState();

  useImperativeHandle(ref, () => ({

    getSamplers () {
      return samplers;
    },

    setGain (id, value) {
      if (gainNodes[id]) {
        gainNodes[id].gain.rampTo(value, 0.1);
      }
    },

    setFreq (id, value) {
      // console.log(`setFreq ${id}: ${value}`);
      if (samplers[id]) {
        samplers[id].playbackRate = value;
      }
    },

    play,
    stop,
    stopMonitor,
    stopAll,
    monitorSample,
    addSampler,
    removeSampler,
    loadSoundBank
  }));

  useEffect(() => {
    onSamplerLoad();
  }, []);

  const play = (id, playbackRate = 1) => {
    if (samplers[id] && samplers[id].loaded) {
      samplers[id].playbackRate = playbackRate;
      samplers[id].start();
    }
  };

  function stopAll () {
    for (const sampler in samplers) {
      samplers[sampler]?.stop();
    };
  };

  function stop (id) {
    const fadeOutTime = 0.1; // in ms
    gainNodes[id]?.gain.rampTo(0, fadeOutTime); // TODO: use amplitudeEnvelope to prevent click on stop
    // const timeNow = Date.now();

    setTimeout(() => {
      if (samplers[id]) {
        // console.log('timePassed (ms): ', Date.now() - timeNow);
        samplers[id].stop();
      }
    }, fadeOutTime);
  };

  const monitorSample = (id) => {
    stopMonitor();
    setMonitor(id);
    samplers[id].start();
  };

  const stopMonitor = () => {
    monitor && (samplers[monitor].stop());
    setMonitor(null);
  };

  const onSamplerLoad = () => {
    // setSamplerLoaded(true);
    // addSampler('testSampler', Textures.one);
  };

  const loadSoundBank = (soundBank) => {
    Object.keys(samplers).forEach((key, index) => {
      const soundBankKey = key.split('_')[1];
      const texture = soundBank.find(obj => obj.name === soundBankKey);
      loadNewBuffer(key, texture.soundfile);
    });
  };

  // const onBufferLoad = (file) => {
  //   console.log('Sample' + file + ' loaded');
  // };

  // const onBufferError = (file) => {
  //   console.log('Sample' + file + ' could not be loaded');
  // };

  const loadNewBuffer = async (id, file) => {
    const newBuffer = new Tone.Buffer(file);
    samplers[id].buffer.set(newBuffer);
  };

  const addSampler = (id, texture, loop = true, initialGain = 1) => {
    const newSamplers = samplers;
    const newGainNodes = gainNodes;
    const player = new Tone.Player({
      url: texture.soundfile,
      onload: () => console.log(`sample ${texture.soundfile} loaded`)
    });
    player.loop = loop;

    const gainNode = new Tone.Gain(initialGain).toDestination();
    player.connect(gainNode);
    newGainNodes[id] = gainNode;
    newSamplers[id] = player;
    setSamplers(newSamplers);
    setGainNodes(newGainNodes);
  };

  const removeSampler = (id) => {
    if (!gainNodes[id]) {
      console.warn(`Cannot remove Sampler. Sampler ${id} does not exist`);
      return;
    }
    const fadeOutTime = 100; // in ms
    gainNodes[id].gain.rampTo(0, 0.1);

    setTimeout(() => {
      const newSamplers = samplers;
      newSamplers[id].stop();
      const newGainNodes = gainNodes;
      delete newSamplers[id];
      delete newGainNodes[id];
      setSamplers(newSamplers);
      setGainNodes(newGainNodes);
    }, fadeOutTime);
  };

  return (
    <div>
      {/* {samplerLoaded && (
        <div>
          {Object.keys(samplers).map((key) => (
            <div key={key}>
              <h3>Sampler {key}</h3>
              <label htmlFor={`pitch-slider-${key}`}>
                //Pitch: {pitchValues[index]}
              </label>
              <input
                type="range"
                min="-12"
                max="12"
                step="1"
                // value={pitchValues[index]}
                id={`pitch-slider-${key}`}
                onChange={(e) => handlePitchChange(e, key)}
              />
              <button
                onClick={() => handlePlay(key)}
                >Play
              </button>
            </div>
          ))}
        </div>
      )} */}
      {/* <div

      >
        <button
          onClick={onSamplerLoad}
        >Load Samples</button>
      </div> */}
    </div>
  );
});

export default React.memo(SamplePlayer);
